import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SessionInfoDto } from 'api/auth/authApi.types';
import { login } from 'prequalificationV2/thunks';

export const VERIFICATION_CODE_LENGTH = 6;

export const initialVerificationCodeValues = Array<string>(VERIFICATION_CODE_LENGTH).fill('');

export enum AccountActionType {
  ConfirmNewPassword = 'account/confirm-new-password',
}

export interface CreateAccountDataResponse {
  sessionInfo: SessionInfoDto;
  borrowerId: string;
}

export interface ResetPasswordDTO {
  password: string;
  resetPasswordToken: string;
}

export interface AccountState {
  email: string;
  emailError: string;
  passwordError: string;
  phone: string;
  showNotification: boolean;
  sessionInfo: SessionInfoDto | null;
  id: string;
}

const initialState: AccountState = {
  email: '',
  phone: '',
  emailError: '',
  passwordError: '',
  showNotification: false,
  sessionInfo: null,
  id: '',
};

const account = createSlice({
  name: 'account',
  initialState: initialState,
  reducers: {
    setAccount: (state, { payload }: PayloadAction<Partial<AccountState>>) => {
      Object.assign(state, payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.fulfilled, (state, { payload }: PayloadAction<SessionInfoDto>) => {
      state.sessionInfo = payload;
    });
  },
});

export const { setAccount } = account.actions;
export default account.reducer;
